import React from 'react';

import { Typography } from '@material-ui/core';

import { t } from '~/helpers';

import * as S from './styles';

export default function Loading() {
  return (
    <S.Wrapper>
      <Typography>{t('s.operacao.turno.atualizandodados')}</Typography>
      <S.WrapperLoading />
    </S.Wrapper>
  );
}
